import AuthServiceInterface, {
  LoginInput,
  Code,
} from './interfaces/AuthServiceInterface';
import HttpInterface from '../infra/http/HttpInterface';

export default class AuthService implements AuthServiceInterface {
  constructor(readonly httpClient: HttpInterface, readonly baseUrl: string) {}

  async sendCode(model: Code): Promise<any> {
    return this.httpClient.request(
      `${this.baseUrl}/api/auth/code`,
      model,
      'post'
    );
  }

  async login(model: LoginInput): Promise<any> {
    return this.httpClient.request(
      `${this.baseUrl}/api/auth/login`,
      model,
      'post'
    );
  }

  async logout(): Promise<any> {
    return this.httpClient.request(
      `${this.baseUrl}/api/auth/logout`,
      null,
      'post'
    );
  }
}
